// 商品セクションと展示会 quick-view dialog の双方で使うため、セクションの javascript タグではなく
// asset に置き、描画するセクションが個別に読み込む（#98）

class CedarwoodSizePicker extends HTMLElement {
  connectedCallback() {
    this.productInfo = this.closest('product-info');
    this.form = document.getElementById(this.dataset.formId);
    this.idInput = this.form ? this.form.querySelector('.product-variant-id') : null;
    this.buttons = Array.from(this.querySelectorAll('.c_p-product__variant'));

    // 本文中とモバイルバーの2つのカート追加ボタンをまとめて制御
    const scope = this.productInfo || document;
    this.submits = Array.from(scope.querySelectorAll('button[name="add"]'));

    this.buttons.forEach((btn) => {
      btn.addEventListener('click', () => this.onSelect(btn));
      btn.addEventListener('keydown', (event) => this.onKeydown(event, btn));
    });
    this.syncTabStops();

    const initial = this.buttons.find((b) => b.getAttribute('aria-checked') === 'true');
    if (initial) this.commit(initial.dataset.variantId);
  }

  get peers() {
    return Array.from(document.querySelectorAll('cedarwood-size-picker')).filter(
      (p) => p.dataset.formId === this.dataset.formId,
    );
  }

  onSelect(btn) {
    if (btn.dataset.available !== 'true') return;
    this.peers.forEach((p) => p.mark(btn.dataset.variantId));
    this.commit(btn.dataset.variantId);
  }

  onKeydown(event, btn) {
    const keys = ['ArrowRight', 'ArrowDown', 'ArrowLeft', 'ArrowUp', 'Home', 'End'];
    if (keys.indexOf(event.key) === -1) return;
    event.preventDefault();
    const index = this.buttons.indexOf(btn);
    let next = 0;
    if (event.key === 'End') {
      next = this.buttons.length - 1;
    } else if (event.key !== 'Home') {
      let step = 1;
      if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') step = -1;
      next = (index + step + this.buttons.length) % this.buttons.length;
    }
    this.buttons[next].focus();
    this.onSelect(this.buttons[next]);
  }

  syncTabStops() {
    const selected = this.buttons.find((b) => b.getAttribute('aria-checked') === 'true');
    const first = this.buttons.find((b) => b.dataset.available === 'true') || this.buttons[0];
    const stop = selected || first;
    this.buttons.forEach((b) => {
      b.tabIndex = b === stop ? 0 : -1;
    });
  }

  mark(variantId) {
    this.buttons.forEach((b) => {
      const on = b.dataset.variantId === variantId;
      b.classList.toggle('is-selected', on);
      b.setAttribute('aria-checked', on ? 'true' : 'false');
    });
    this.syncTabStops();
  }

  commit(variantId) {
    if (this.idInput) {
      this.idInput.value = variantId;
      this.idInput.removeAttribute('disabled');
    }
    this.submits.forEach((btn) => btn.removeAttribute('disabled'));
  }
}

if (!customElements.get('cedarwood-size-picker')) {
  customElements.define('cedarwood-size-picker', CedarwoodSizePicker);
}
